import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import STATUS from './constants';

const { COMPLETE, PROCESS, WAIT } = STATUS;
const { node, number, oneOf, string } = PropTypes;

/**
 * Steps
 *
 * This component is in charge of displaying
 * some steps
 *
 * @param {string} className // Classes needed by styled component.
 * @param {any} children // Any component or dom element.
 * @param {number} current // The current step number.
 * @param {string} status // The actual status of a step (COMPLETE, PROCESS, WAIT).
 *
 * @return {jsx}
 */

class Steps extends Component {
  /**
   * PropTypes Validation
   */
  static propTypes = {
    className: string,
    children: node,
    current: number,
    status: oneOf([COMPLETE, PROCESS, WAIT]),
  };

  /**
   * Default Props
   */
  static defaultProps = {
    className: '',
    children: null,
    current: 1,
    status: PROCESS,
  };

  /**
   * Render function
   */
  render() {
    const { className, children, current, status } = this.props;

    return (
      <ol className={className}>
        {Children.map(children, (child, index) => {
          const childProps = {
            stepNumber: `${index + 1}`,
          };
          if (index + 1 === current) {
            childProps.status = status;
          } else if (index + 1 < current) {
            childProps.status = COMPLETE;
          } else {
            childProps.status = WAIT;
          }
          return cloneElement(child, { ...childProps });
        })}
      </ol>
    );
  }
}

export default styled(Steps)`
  display: flex;
  justify-content: space-between;

  list-style-type: none;

  padding: 1.3rem 2.2rem;

  font-size: ${({ theme: { fonts } }) => fonts.size.medium};

  color: ${({ theme: { palette } }) => palette.darkGrey};

  border-bottom: 1px solid ${({ theme: { palette } }) => palette.lightGrey};

  /* For small devices */
  ${breakpoint('xs', 'md')`
    flex-direction: column;
    align-items: stretch;
    padding: 0;
    border-bottom: none;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Steps/index.js